import {
  MIN_CITATION_WORDS,
  wordCount,
} from 'js/journals/article/citationFormatting';

export const CITABLE_CONTENT_SELECTOR =
  '#sap-article-body .sap__body, #sap-article-body .sap__front-container > .sap__front > .sap__section:not(#article-podcast)';

export function isCitableSelection(
  range: Range,
  roots: Iterable<Element>,
  text: string,
): boolean {
  return (
    Array.from(roots).some(
      (root) =>
        root.contains(range.startContainer) &&
        root.contains(range.endContainer) &&
        !Array.from(
          root.querySelectorAll(
            '#article-keywords, [data-sap-translated-abstract]',
          ),
        ).some((element) => range.intersectsNode(element)),
    ) && wordCount(text) >= MIN_CITATION_WORDS
  );
}

export const FORMULA_SELECTOR =
  'mjx-container, math, .sap__inline-formula, .sap__disp-formula';

export function selectionContainsFormula(range: Range): boolean {
  const node = range.commonAncestorContainer;
  const root = node instanceof Element ? node : node.parentElement;
  return (
    !!root &&
    (!!root.closest(FORMULA_SELECTOR) ||
      Array.from(root.querySelectorAll(FORMULA_SELECTOR)).some((formula) =>
        range.intersectsNode(formula),
      ))
  );
}
